<div
  class="flex flex-column align-items-center justify-content-center h-full w-full maintenance-container"
>
  <div class="text-center mb-3">
    <img
      src="assets/img/website-under-construction.jpg"
      alt="Sitio web en construcción"
      class="w-full max-w-24rem md:max-w-25rem lg:max-w-30rem"
    />
  </div>
  <h1 class="text-2xl md:text-4xl font-bold text-center mb-2 m-0 text-white">
    ¡Estamos trabajando en algo increíble!
  </h1>
  <p class="text-center text-lg md:text-xl text-600 px-3 md:px-6 text-white">
    Esta página está en construcción, vuelve pronto para ver nuestras
    actualizaciones.
  </p>
</div>
